if (!customElements.get('auzi-card-variants')) {
  const images = new Map();
  const queue = [];
  let active = 0;
  const pump = () => {
    while (active < 3 && queue.length) {
      active++;
      const {url,resolve} = queue.shift();
      const image = new Image();
      image.src = url;
      image.decode().then(() => resolve(true), () => { images.delete(url); resolve(false); }).finally(() => { active--; pump(); });
    }
  };
  const preload = (url, priority = false) => {
    if (!url) return Promise.resolve(false);
    if (!images.has(url)) images.set(url, new Promise(resolve => { queue[priority ? 'unshift' : 'push']({url,resolve}); }));
    if (priority) { const i=queue.findIndex(job=>job.url===url); if(i>0) queue.unshift(queue.splice(i,1)[0]); }
    pump();
    return images.get(url);
  };
  customElements.define('auzi-card-variants', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const data = this.querySelector('[data-card-variants]');
      if (!data) return;
      this.initialized = true;
      const model = JSON.parse(data.textContent);
      let selected = model.selected;
      let desiredSelection = [...selected];
      const groups = [...this.querySelectorAll('[data-option-index]')];
      let request = 0;
      let animation;
      const card = this.closest('.product-card-wrapper');
      if (groups.length) {
        card?.classList.add('auzi-variant-preview');
        const initial = model.variants.find(v => v.options.every((value, i) => value === selected[i]));
        if (initial) {
          const url = new URL(this.dataset.productUrl, location.origin);
          url.searchParams.set('variant', initial.id);
          card?.querySelectorAll('.card__heading a, .card__media a').forEach(link => { link.href = url.href; });
        }
      }
      const warm = () => [...new Set(model.variants.map(v=>v.image).filter(Boolean))].forEach(url=>preload(url));
      const observer = new IntersectionObserver(entries => { if(entries.some(e=>e.isIntersecting)) { warm(); observer.disconnect(); } }, {rootMargin:'100px'});
      observer.observe(this);
      this.addEventListener('click', async event => {
        const button = event.target.closest('button[data-value]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const index = Number(button.closest('[data-option-index]').dataset.optionIndex);
        const desired = [...desiredSelection];
        desired[index] = button.dataset.value;
        const variant = model.variants.find(v => v.options.every((value, i) => value === desired[i]));
        if (!variant?.image) return;
        desiredSelection = variant.options;
        const currentRequest = ++request;
        const image = card?.querySelector('.card__media img');
        if (image && variant.image) {
          this.setAttribute('aria-busy','true');
          const ready = await preload(variant.image, true);
          if (currentRequest !== request) return;
          this.removeAttribute('aria-busy');
          if (!ready) { desiredSelection = [...selected]; return; }
          selected = variant.options;
          const price = card.querySelector('[data-auzi-card-price]');
          if (price) {
            price.querySelector('[data-current-price]').innerHTML = variant.priceText;
            const compare = price.querySelector('[data-compare-price]');
            compare.hidden = !(variant.compareAt > variant.price);
            compare.innerHTML = compare.hidden ? '' : variant.compareText;
            price.dataset.auziBasePriceCents = String(variant.price || 0);
            price.dataset.auziComparePriceCents = String(variant.compareAt || 0);
            price.dataset.auziAvailable = variant.available ? 'true' : 'false';
            document.dispatchEvent(new CustomEvent('auzi:card-price-change', { detail: { root: price } }));
          }
          groups.forEach(group => {
            const i = Number(group.dataset.optionIndex);
            group.querySelector('[data-option-label]').textContent = selected[i];
            group.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.value === selected[i])));
          });
          const url = new URL(this.dataset.productUrl, location.origin);
          url.searchParams.set('variant', variant.id);
          card.querySelectorAll('.card__heading a, .card__media a').forEach(link => { link.href = url.href; });
          animation?.cancel();
          const changed = image.getAttribute('src') !== variant.image;
          image.removeAttribute('srcset');
          image.src = variant.image;
          image.alt = variant.alt;
          card.classList.add('auzi-variant-preview');
          if (changed && !matchMedia('(prefers-reduced-motion: reduce)').matches) animation=image.animate([{opacity:0.75},{opacity:1}],{duration:150,easing:'ease-out'});
        } else {
          this.removeAttribute('aria-busy');
        }
      });
    }
  });
}
